import React from 'react';
interface PricingDetail {
  label: string;
  value: string;
}
interface PricingItem {
  description: string;
  details?: PricingDetail[];
  unitPrice: number;
  quantity: number;
  tax: number;
  amount: number;
}
interface QuotationPricingProps {
  items: PricingItem[];
}
export function QuotationPricing({
  items
}: QuotationPricingProps) {
  const formatCurrency = (amount: number) => {
    return `$${amount.toFixed(2)}`;
  };
  return <div className="mb-6" data-id="element-932">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-933">
        Pricing Breakdown
      </h3>

      {/* Table Header */}
      <div className="grid grid-cols-12 gap-4 pb-3 border-b-2 border-neutral-300 mb-4" data-id="element-934">
        <div className="col-span-5 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-935">
          Description
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-936">
          Unit Fare
        </div>
        <div className="col-span-1 text-sm font-semibold text-neutral-700 text-center uppercase tracking-wide" data-id="element-937">
          Qty
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-938">
          GST
        </div>
        <div className="col-span-2 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-939">
          Amount
        </div>
      </div>

      {/* Pricing Items */}
      {items.map((item, index) => <div key={index} className="border-b border-neutral-200 pb-5 mb-5 last:border-b-0" data-id="element-940">
          <div className="grid grid-cols-12 gap-4 mb-3" data-id="element-941">
            {/* Description Column - Contains ALL descriptive content */}
            <div className="col-span-5" data-id="element-942">
              <p className="font-bold text-neutral-900 mb-2" data-id="element-943">
                {item.description}
              </p>

              {/* Nested Details - Matching Invoice format exactly */}
              {item.details && item.details.length > 0 && <div className="pl-3 border-l-2 border-neutral-200 space-y-1" data-id="element-944">
                  {item.details.map((detail, detailIndex) => <div key={detailIndex} className="flex text-sm" data-id="element-945">
                      <span className="text-neutral-500 min-w-[140px] font-medium" data-id="element-946">
                        {detail.label}:
                      </span>
                      <span className="text-neutral-700" data-id="element-947">{detail.value}</span>
                    </div>)}
                </div>}
            </div>

            {/* Numeric Columns - ONLY numeric values */}
            <div className="col-span-2 text-right text-neutral-900 tabular-nums" data-id="element-948">
              {formatCurrency(item.unitPrice)}
            </div>
            <div className="col-span-1 text-center text-neutral-900 tabular-nums" data-id="element-949">
              {item.quantity}
            </div>
            <div className="col-span-2 text-right text-neutral-900 tabular-nums" data-id="element-950">
              {formatCurrency(item.tax)}
            </div>
            <div className="col-span-2 text-right font-semibold text-neutral-900 tabular-nums" data-id="element-951">
              {formatCurrency(item.amount)}
            </div>
          </div>
        </div>)}
    </div>;
}